export default {
  text: 'Käyttämällä tätä verkkosivustoa hyväksyt',
  cookie_policy: 'evästekäytäntömme.',
  buttons: {
    accept: 'Hyväksy',
    reject: 'Hylkää',
  },
};
